import React, { Component } from 'react';
import {Grid, GridColumn, GridRow} from '@react/react-spectrum/Grid';
import Button from '@react/react-spectrum/Button';
import {ATTACH_MAX_SIZE, MSG_ATTACH_MAX_SIZE_ERROR} from '../../config/constants';

class Attachment extends Component {
    fileUploadClick = () => {
        if (this.props.disabled) return;
        document.getElementById("brfileinput").click();   
    }

    onFileChange = (e, props, updateValidation) => {
        if (this.props.disabled) return;
        const file = e.target.files[0];
        var fileReader = new FileReader();
        let _self = this;
        fileReader.onloadend = function() {
            const attachment = window.btoa(this.result);
            props.change("attachmantName", file.name);
            props.change("contentType", file.type);
            props.change("attachmantBody", attachment);
            updateValidation("attachment",true);
        }
        
        if(Boolean(file))
        {
            if(file.size < ATTACH_MAX_SIZE)
            {
                this.setState({file,isSaving:false});
                fileReader.readAsBinaryString(file);
            }
            else{
                //Error msg label : SplznRequiredExceededSizeMsg
                alert(MSG_ATTACH_MAX_SIZE_ERROR);
            }          
        }
    }

    render() {
        let {updateValidation} = this.props;
        return(
        <GridRow style={{ "margin": "1px", "paddingTop": "10px" }}>
            <GridColumn size={[12, 12, 12, 12]} >
                <Button variant="cta" disabled={this.props.disabled} onClick={this.fileUploadClick} >Choose File</Button> 
                <input id='brfileinput' type='file' name='filename' disabled={this.props.disabled} onChange={(e) => this.onFileChange(e, this.props, updateValidation)} data-max-size="30" hidden />
                {/*<Button variant="cta" onClick={() => {  }}>Choose File</Button> */}
                <span className="spectrum-Button" style={{"border": "none"}}>{this.props.formStates.attachmantName ? this.props.formStates.attachmantName : "No file chosen."}</span>
            </GridColumn>
        </GridRow>
        )
    }
}

export default Attachment;